export const KEY = 'siteAttributeGroup';
export const PARAM_KEY = 'siteAttributeGroupId';
